import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-list-csh",
  "use": "icon-file-list-csh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-list-csh\"><defs><style type=\"text/css\"></style></defs><path d=\"M365.568 402.432h290.816v71.68H365.568v-71.68z m0 145.408h290.816v71.68H365.568v-71.68z m0 145.408h290.816v71.68H365.568v-71.68zM873.472 40.96H293.888C215.04 40.96 149.504 104.448 149.504 185.344v652.288H4.096C4.096 917.504 67.584 983.04 149.504 983.04h580.608c78.848 0 145.408-64.512 145.408-145.408V257.024h145.408v-71.68C1017.856 104.448 954.368 40.96 873.472 40.96z m-71.68 784.384c0 47.104-37.888 84.992-84.992 84.992H185.344c35.84-24.576 35.84-71.68 35.84-71.68V185.344c0-39.936 31.744-71.68 71.68-71.68s71.68 31.744 71.68 71.68v71.68h435.2v567.296h2.048zM439.296 185.344v-71.68h435.2c65.536 0 71.68 41.984 71.68 71.68H439.296z\" fill=\"#BABABA\" p-id=\"11503\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-list-csh.svg
// module id = Tloy
// module chunks = 20